<template>
    <div class="w-full bg-black text-white p-4 mb-3 md:mb-12 flex flex-wrap border-l-24 border-red" v-if="showRequirements">
        <div class="pr-4 mb-3 md:mb-0 w-full md:w-1/2">
            <p>IMPORTANT: You must complete the Collaborator Agreement before submitting your event.</p>
        </div>
        <div class="w-full md:w-1/2 flex flex-wrap md:justify-end">
            <template v-if="! contractOverride">
                <div v-if="hasSignedContract" class="flex items-center text-white text-lg mr-8">
                    <span class="mr-2 text-base">Collaborator Agreement</span>
                    <svg width="24" height="25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 .478h23.523V24H0z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(0 .273)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M18.414 18.892c-3.673 3.674-9.631 3.674-13.306 0a9.408 9.408 0 0 1 0-13.306 9.409 9.409 0 1 1 13.306 13.306M3.444 3.922c-4.592 4.593-4.592 12.04 0 16.633 4.594 4.594 12.04 4.594 16.634 0 4.593-4.593 4.593-12.04 0-16.633s-12.04-4.593-16.633 0" fill="#FFF" mask="url(#b)"/></g><path d="M10.585 18.392c-.28 0-.552-.1-.766-.284L5.702 14.57a1.176 1.176 0 0 1 1.533-1.784l3.109 2.671 5.143-7.715a1.176 1.176 0 1 1 1.958 1.305l-5.882 8.82a1.171 1.171 0 0 1-.978.525" fill="#FFF"/></g></svg>
                </div>
                <div class="flex items-center mr-8" v-else>
                    <router-link :to="`/events/${eventId}/contracts/${contractId}/sign`" class="text-white text-base mr-2">
                        Collaborator Agreement
                    </router-link>
                    <svg width="24" height="25" xmlns="http://www.w3.org/2000/svg"><path d="M12 22.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm0 2c-6.627 0-12-5.373-12-12S5.373.5 12 .5s12 5.373 12 12-5.373 12-12 12z" fill="#FFF" fill-rule="evenodd"/></svg>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'EventRequirements',
        data: () => ({
            signed: false,
            creditAuthorization: false
        }),
        computed: {
            ...mapGetters({
                event: 'event',
                user: 'user'
            }),
            showRequirements() {

                if( this.event === 'needs review') {
                    return false
                }

                if( ( this.hasSignedContract || this.contractOverride )) {
                    return false
                }

                return true
            },
            contractOverride() {
                return (this.event && this.event.organization) ? this.event.organization.contractOverride : false
            },
            hasSignedContract() {
                return (this.user && this.user.hasSignedContract) ? true : false
            },
            contractId() {
                return (this.event && this.event.festival) ? this.event.festival.contractId : null
            },
            eventId() {
                return (this.event) ? this.event.id : null
            }
        },
        watch: {},
        methods: {},
        mounted() {

        }
    }
</script>
